import { images } from "@img/imagesMap";
import { Link, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import Nav from "@components/Nav";
import { useLoginUser, useIsAdmin, useProfileImageUrl } from "@hooks/useAuth";
import { cn } from "@/utils/cn";
import { ChevronRight } from "lucide-react";
import iconProfile from "@img/icon/icon_profile.svg";

function Aside() {
  const loginUser = useLoginUser();
  const isAdmin = useIsAdmin();
  const profileImageUrl = useProfileImageUrl();
  // const isSeosan = false;

  const navigate = useNavigate();

  // 프로필 이미지 결정: 로그인 상태에 따라 기본 아이콘 또는 유저 프로필 이미지
  const displayImageUrl = loginUser ? profileImageUrl : iconProfile;

  function c_menuResizing() {
    const gridWrap = document.querySelector(
      ".c_page__container"
    ) as HTMLElement | null;
    const menuWrap = gridWrap?.querySelector(
      ".c_pageHeader__container"
    ) as HTMLElement | null;
    const handler = menuWrap?.querySelector(
      ".c_pageHeader__resizeHandler"
    ) as HTMLElement | null;

    let isResizing: boolean = false;
    let startX: number, initialWidth: number;

    function caseMouseDown(e: MouseEvent) {
      document.body.classList.add("us-n");
      gridWrap?.classList.add("t-n");
      isResizing = true;
      startX = e.screenX;
      initialWidth = parseInt(
        getComputedStyle(document.documentElement).getPropertyValue(
          "--width-menu"
        )
      );
    }
    function caseMouseMove(e: MouseEvent) {
      if (isResizing) {
        let newWidth: number = initialWidth + (e.screenX - startX);
        newWidth = Math.max(
          180,
          Math.min(newWidth, window.innerWidth - window.innerWidth * 0.5)
        );
        document.documentElement.style.setProperty(
          "--width-menu",
          `${newWidth}px`
        );
      }
    }
    function caseMouseUp() {
      if (isResizing) {
        isResizing = false;
        document.body.classList.remove("us-n");
        gridWrap?.classList.remove("t-n");
      }
    }

    handler?.addEventListener("mousedown", caseMouseDown);
    window.addEventListener("mousemove", caseMouseMove);
    window.addEventListener("mouseup", caseMouseUp);
  }

  useEffect(() => {
    c_menuResizing();
  }, []);

  return (
    <header className="c_pageHeader__container">
      <Link to="/" className="c_pageHeader__mainLogo">
        <h1>
          <img src={images.logo_onmaum} alt="" />
          {/* <img src={images.logo_seosan} alt="" /> */}
          <span className="c_common__btnClipText">
            환자안전, 감염관리, 의료기관 평가인증을 위한 대화형 인공지능, 에이드
          </span>
        </h1>
      </Link>

      <div className="flex flex-col justify-center  min-w-[160px]  p-4 py-6 gap-4 border-b">
        <div className="c_userInfo__nameWrap flex items-center group mt-2">
          <div className="c_userInfo__picture">
            <img src={displayImageUrl} alt="" />
          </div>
          <p
            className={cn(
              "text-lg font-bold text-gray-800 flex items-center gap-2",
              loginUser &&
                "group-hover:text-fix_color_btnBlue hover:cursor-pointer"
            )}
            {...(loginUser && {
              onClick: () => navigate("/myPage"),
            })}
          >
            {loginUser ? loginUser.name : "환영합니다"}
            {loginUser && (
              <ChevronRight className="size-4 group-hover:translate-x-1 transition-transform duration-300 opacity-30 group-hover:opacity-60" />
            )}
          </p>
        </div>

        <div className="text-sm text-gray-500 grid grid-cols-[1fr_auto] items-center ">
          {/* office_id */}
          <span className=" break-keep">
            {loginUser
              ? `${loginUser.office_name} ${loginUser.mb_part_name} `
              : "로그인해주세요"}
          </span>

          {loginUser?.is_head_nurse && (
            <span className="border-l   border-zinc-300 pl-1.5">
              {loginUser?.official_title_name}
            </span>
          )}
        </div>
      </div>

      {/*Nav*/}
      <Nav loginUser={loginUser} />

      {/* 불필요한듯 */}
      {/* <div className="c_pageHeader__resizeHandler"></div> */}
    </header>
  );
}

export default Aside;
